module.exports = {"description":"Hệ thống hậu trường trung tâm đám mây","username":"Hãy nhập tên người dùng","password":"Xin vui lòng nhập mật khẩu","login":"Đăng nhập"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/zh-VIE.json
// module id = OTWI
// module chunks = 72